import React, {useEffect, useState} from 'react';
import FormEse from "./add/FormEse";
import LibToast from "../../lib/LibToast";
import Api from "../../servicios/api/Api";


const apiCliente = Api.getApiCliente();

const getValidation = (model) => {
  let isValid = true;
  ['id_tipo_ese_string', 'evaluado', 'puesto', 'email', 'tel'].forEach(p => {
    if (!model[p]) {
      isValid = false;
    }
  });
  
  return isValid;
}


const AddEse = ({listaTipo, onEseInserted}) => {
  
  const [model, setModel] = useState({})
  
  
  if (!listaTipo) {
    return null;
  }
  
  const onSubmit = async (event) => {
    event.preventDefault();
    
    const isValid = getValidation(model);
    
    if (!isValid) {
      LibToast.alert("Datos invalidos, falta completar el formulario");
      return;
    }
    
    
    const att = {...model, id_tipo_ese: parseInt(model.id_tipo_ese_string)}
    
    const response = await apiCliente.crearEse(att);
    
    if (!response.success) {
      LibToast.alert("Error al guardar el registro " + response.message);
      return;
    }
    LibToast.success("Registro Agregado")
    
    const ese = response.data.ese;
    
    console.log('ese - ',JSON.stringify(ese));
    setModel({});
    onEseInserted(ese);
  }
  
  
  const onChange = (modelNew) => {
    setModel(modelNew)
  }
  
  return (
    <>
      <div className="divFlex">
        <h2 className="subtitle flexGrow1">
          <i className="fa fa-plus m5R"/>
          Solicitar Estudio
        </h2>
        <button className="button is-primary" onClick={() => setModel({})}>Limpiar</button>
      </div>
      
      <FormEse
        modelNew={model}
        submit={onSubmit}
        onChange={onChange}
        listaTipo={listaTipo.filter(k => !k.is_no_activo)}/>
    
    </>
  
  )
    ;
  
  
};

export default AddEse